<template>
  <div>
    <v-tabs hide-slider vertical class="overflow-fix">
      <p class="pa-1 primary rounded white--text text-center d-inline-block">{{ $t('companyLabel') }}: <span class="font-weight-bold">{{ this.company.name1 }}</span></p>
      <v-tab class="d-flex justify-start text-wrap text-left"> {{$t('profileLabel')}} </v-tab>
      <v-tab :ripple="false" class="submenu pl-8 d-flex justify-start text-wrap text-left">
        > {{ $t('incotermsLabel') }}
      </v-tab>
      <v-tab :ripple="false" class="submenu pl-8 d-flex justify-start text-wrap text-left">
        > {{ $t('paymentTermsLabel') }}
      </v-tab>
      <v-tab :ripple="false" class="submenu pl-8 d-flex justify-start text-wrap text-left">
        > {{ $t('pricelistLabel') }}
      </v-tab>
      <v-tab v-if="isAdmin && isWertheimTurkonfigurator" class="d-flex justify-start text-wrap text-left">
        {{ $t('wertheimSalesLabel') }}
      </v-tab>
      <v-tab class="d-flex justify-start text-wrap text-left">
        {{ $t('spaLabel') }}
      </v-tab>
      <v-tab class="d-flex justify-start text-wrap text-left">
        {{ $t('spsLabel') }}
      </v-tab>
      <v-tab class="d-flex justify-start text-wrap text-left">
        {{ $t('sppcLabel') }}
      </v-tab>
      <v-tab class="d-flex justify-start text-wrap text-left">
        {{ $t('apsLabel') }}
      </v-tab>

      <v-tab-item>
        <v-card flat class="pl-9">
          <v-card-text class="pa-0">
            <div class="d-flex mb-5">
              <div class="black--text text-h5">{{ $t('profileLabel') }}</div>
            </div>
          </v-card-text>
          <CompanyProfile :isAdmin="isAdmin" v-bind:companyId="parseInt(this.$route.params.companyId)"
            v-bind:showUserPath="'/dashboard/wa-user/'" />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="pl-9">
          <v-card-text class="pa-0">
            <div class="d-flex mb-5">
              <div class="black--text text-h5">{{ $t('incotermsLabel') }} </div>
            </div>
          </v-card-text>
          <div class="incoterms mb-4" style="height:100%">
            <v-row class="">
              <div class="col-8 icoterm-dropdown">
                <v-autocomplete deletable-chips chips item-text="incotermText" hide-details single-line multiple
                  outlined :label="$t('selectIncoterms')" :items="incoterms" v-model="selectedIncoterms" return-object>
                </v-autocomplete>
              </div>
              <div class="col-4 button">
                <v-btn :loading="loadingIncoterms" height="100%" width="100%" class="green white--text" @click="saveIncoterms">{{ $t('saveIncotermsLabel') }}</v-btn>
              </div>
            </v-row>
          </div>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="pl-9">
          <v-card-text class="pa-0">
            <div class="d-flex mb-5">
              <div class="black--text text-h5">{{ $t('paymentTermsLabel') }}</div>
            </div>
          </v-card-text>
          <div class="payment-terms mb-4">
            <v-row class="">
              <div class="col-8 payment-terms-dropdown">
                <v-autocomplete deletable-chips chips single-line multiple hide-details outlined :label="$t('selectPaymentTerms')"
                  item-text="paymentTermText" :items="paymentTerms" v-model="selectedPaymentTerms" return-object>
                </v-autocomplete>
              </div>
              <div class="col-4 button">
                <v-btn :loading="loadingPaymentTerms" height="100%" width="100%" max-width="100%" class="green white--text" @click="savePaymentTerms">
                  {{$t('savePaymentTermsLabel')}}</v-btn>
              </div>
            </v-row>
          </div>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="pl-9">
          <v-card-text class="pa-0">
            <div class="d-flex mb-5">
              <div class="black--text text-h5">{{$t('pricelistLabel')}}</div>
            </div>
          </v-card-text>
          <div class="pricelist mb-4">
            <v-row class="">
              <div class="col-8 payment-terms-dropdown">
                <v-autocomplete deletable-chips chips single-line hide-details multiple outlined :label="$t('selectPricelist')"
                  :items="priceList" v-model="selectedPricelist" item-text="priceListTypeText" return-object>
                </v-autocomplete>
              </div>
              <div class="col-4 button">
                <v-btn :loading="loadingPricelist" height="100%" width="100%" max-width="100%" class="green white--text" @click="savePricelist">{{$t('savePricelistLabel')}}</v-btn>
              </div>
            </v-row>
          </div>
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="isAdmin && isWertheimTurkonfigurator">
        <v-card flat class="pl-9">
          <v-card-text class="pa-0">
            <div class="d-flex mb-5">
              <div class="black--text text-h5 text-center">
                {{ $t('wertheimSalesLabel') }}
              </div>
            </div>
          </v-card-text>
          <WertheimSales :companyId="parseInt(this.$route.params.companyId)"/>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="pl-9">
          <v-card-text class="pa-0">
            <div class="d-flex mb-5">
              <div class="black--text text-h5 text-center">
                {{ $t('spaLabel') }}
              </div>
            </div>
          </v-card-text>
          <PartnershipAdministratorsTable v-bind:companyId="parseInt(this.$route.params.companyId)"
            v-bind:showUserPath="'/dashboard/wa-user/'" />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="pl-9">
          <v-card-text class="pa-0">
            <div class="d-flex mb-5">
              <div class="black--text text-h5 text-center">
                {{ $t('spsLabel') }}
              </div>
            </div>
          </v-card-text>
          <PartenershipSaleUsersTable v-bind:companyId="parseInt(this.$route.params.companyId)"
            v-bind:showUserPath="'/dashboard/wa-user/'" />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="pl-9">
          <v-card-text class="pa-0">
            <div class="d-flex mb-5">
              <div class="black--text text-h5 text-center">
                {{ $t('sppcLabel') }}
              </div>
            </div>
          </v-card-text>
          <PartnershipProductConfiguratorUsersTable v-bind:companyId="parseInt(this.$route.params.companyId)"
            v-bind:showUserPath="'/dashboard/wa-user/'" />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="pl-9">
          <AffiliatesCompanyTable :tableName="$t('apsLabel')"
            v-bind:parentCompanyId="parseInt(this.$route.params.companyId)" v-bind:canModify="true"
            v-bind:canAddNew="false" />
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
  import CompanyProfile from "../../components/CompanyProfile";
  import WertheimSales from "@/components/WertheimSales";
  import PartnershipAdministratorsTable from "../../components/PartnershipAdministratorsTable";
  import PartenershipSaleUsersTable from "../../components/PartenershipSaleUsersTable";
  import PartnershipProductConfiguratorUsersTable from "../../components/PartnershipProductConfiguratorUsersTable";
  import CompaniesTable from "../../components/CompaniesTable";
  import AffiliatesCompanyTable from "../../components/AffiliatesCompanyTable";
  import UserTypes from "../../auth/userTypes";
  export default {
    components: {
      CompanyProfile,
      WertheimSales,
      PartnershipAdministratorsTable,
      PartenershipSaleUsersTable,
      PartnershipProductConfiguratorUsersTable,
      CompaniesTable,
      AffiliatesCompanyTable,
    },
    data() {
      return {
        company: '',
        isAdmin: false,
        loadingIncoterms: false,
        loadingPaymentTerms: false,
        loadingPricelist: false,
        selectedIncoterms: [],
        selectedPaymentTerms: [],
        selectedPricelist: [],
        companyFetched: false,
        incotermsFetched: false,
        paymentTermsFetched: false,
        pricelistFetched: false,
        incoterms: ["Incoterm 1", "Incoterm 2", "Incoterm 3", "Incoterm 4"],
        paymentTerms: [
          "Payment Term 1",
          "Payment Term 2",
          "Payment Term 3",
          "Payment Term 4",
        ],
        priceList: ["PriceList 1", "PriceList 2", "PriceList 3", "PriceList 4"],
        snackbar: {
          show: true,
          message: "",
        }
      };
    },
    computed:{
      isWertheimTurkonfigurator(){
        return this.company.companyNumber === '0046028907'
      }
    },
    methods: {
      getCompany() {
        var companyId = this.$route.params.companyId
        this.axios
          .get("api/company/getbyid/", {
            params: {
              id: companyId,
            },
          })
          .then((response) => {
            this.company = response.data;
            this.companyFetched = true;
            this.allFetched()
          })
          .catch((error) => {
          });
      },
      async getAllIncoterms() {
        var companyId = this.$route.params.companyId
        this.axios.get("api/company/getAllIncotermsByCompanyWithStatus", { params: {
          companyId : companyId
        } }).then((response) => {
          this.incoterms = response.data;
          this.incoterms.forEach(incoterm => {
            if(incoterm.chosen == true){
              this.selectedIncoterms.push(incoterm)
            }
          });
            this.incotermsFetched = true;
            this.allFetched()
        });
      },
      async getAllPaymentTerms() {
        this.axios.get("api/company/getAllPaymentTermsByCompanyWithStatus", { params: { companyId: this.$route.params.companyId }}).then((response) => {
          this.paymentTerms = response.data;
          this.paymentTerms.forEach(paymentTerm => {
            if(paymentTerm.chosen == true){
              this.selectedPaymentTerms.push(paymentTerm)
            }
          });
            this.paymentTermsFetched = true;
            this.allFetched()
        });
      },
      async getAllPricelist() {
        this.axios.get("api/company/getAllPriceListTypeByCompanyWithStatus", { params: { companyId: this.$route.params.companyId }}).then((response) => {
          this.priceList = response.data;
          this.priceList.forEach(priceList => {
            if(priceList.chosen == true){
              this.selectedPricelist.push(priceList)
            }
          });
            this.pricelistFetched = true;
            this.allFetched()

        });
      },
      async saveIncoterms() {
        this.loadingIncoterms = true
        const incoterms = {
          companyId : this.$route.params.companyId,
          companyIncoterms : this.selectedIncoterms
        }
        this.axios.post("api/company/updateCompanyIncoterms", incoterms).then((response) => {
            this.snackbar.message = this.$t("updatedIncotermsLabel")
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.loadingIncoterms = false
        }).catch((error) => {
          this.snackbar.message = error.message;
          this.$EventBus.$emit("snackbar", this.snackbar);
        });
      },
      async savePaymentTerms() {
        this.loadingPaymentTerms = true
        const paymentTerms = {
          companyId : this.$route.params.companyId,
          companyPaymentTerms : this.selectedPaymentTerms
        }
        this.axios.post("api/company/updateCompanyPaymentTerms", paymentTerms).then((response) => {
            this.snackbar.message = this.$t("updatedPaymentTermsLabel")
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.loadingPaymentTerms = false
        }).catch((error) => {
          this.snackbar.message = error.message;
          this.$EventBus.$emit("snackbar", this.snackbar);
        });
      },
      async savePricelist() {
        this.loadingPricelist = true
        const pricelist = {
          companyId : this.$route.params.companyId,
          companyPricelistTypes : this.selectedPricelist
        }
        this.axios.post("api/company/updateCompanyPricelistTypes", pricelist).then((response) => {
            this.snackbar.message = this.$t("updatedPricelistLabel");
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.loadingPricelist = false
        }).catch((error) => {
          this.snackbar.message = error.message;
          this.$EventBus.$emit("snackbar", this.snackbar);
        });
      },
      canEditData(){
        if (this.$store.state.user.userType == UserTypes.WertheimAdministrator) {
          this.isAdmin = true
        }
        else{
          this.isAdmin = false
        }
      },
      allFetched(){
        if(this.paymentTermsFetched && this.incotermsFetched && this.pricelistFetched && this.companyFetched){
          this.$EventBus.$emit("loading", false);
          return true
        }
        else{
          return false
        }
      }
    },
    mounted() {
      this.getAllIncoterms();
      this.getAllPaymentTerms();
      this.getAllPricelist();
      this.canEditData();
      this.getCompany();
    },
  };
</script>

<style lang="scss">
  .submenu {
    height: 40px !important;
  }
</style>